/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebhookMessageKind = {
    Text: 'TEXT',
    Location: 'LOCATION',
    Image: 'IMAGE',
    Video: 'VIDEO',
    Audio: 'AUDIO',
    RequestLocation: 'REQUEST_LOCATION'
} as const;
export type WebhookMessageKind = typeof WebhookMessageKind[keyof typeof WebhookMessageKind];


export function instanceOfWebhookMessageKind(value: any): boolean {
    for (const key in WebhookMessageKind) {
        if (Object.prototype.hasOwnProperty.call(WebhookMessageKind, key)) {
            if (WebhookMessageKind[key as keyof typeof WebhookMessageKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WebhookMessageKindFromJSON(json: any): WebhookMessageKind {
    return WebhookMessageKindFromJSONTyped(json, false);
}

export function WebhookMessageKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebhookMessageKind {
    return json as WebhookMessageKind;
}

export function WebhookMessageKindToJSON(value?: WebhookMessageKind | null): any {
    return value as any;
}

export function WebhookMessageKindToJSONTyped(value: any, ignoreDiscriminator: boolean): WebhookMessageKind {
    return value as WebhookMessageKind;
}

